<template>
  <div class="card">
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <h3>
              <img
                src="media/icons/duotune/files/fil024.svg"
                class="me-2"
              />Arquivos XML
            </h3>
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            @click="this.carregarArquivos()"
            type="button"
            class="btn btn-sm btn-secondary"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
            </span>
            Atualizar
          </button>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="table-responsive mt-5">
          <table class="table table-hover align-middle gs-2 gy-2">
            <thead>
              <tr>
                <th class="p-0 w-50px"></th>
                <th class="p-0"></th>
                <th class="p-0"></th>
                <th class="p-0"></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!loading">
                <template
                  v-for="(item, index) in diretoriosDownload"
                  :key="index"
                >
                  <tr>
                    <th>
                      <div class="symbol symbol-50px me-2">
                        <span class="symbol-label">
                          <span class="svg-icon svg-icon-3x svg-icon-warning">
                            <inline-svg
                              src="media/icons/duotune/files/fil012.svg"
                            />
                          </span>
                        </span>
                      </div>
                    </th>
                    <td>
                      <span class="text-muted fw-semobold d-block fs-7"
                        >Ano/Mês</span
                      >
                      <a
                        class="text-dark fw-bold text-hover-primary mb-1 fs-6"
                        >{{ item.nome }}</a
                      >
                    </td>
                    <td>
                      <span class="text-muted fw-semobold d-block fs-7"
                        >Arquivos</span
                      >
                      <span class="text-dark fw-bold mb-1 fs-6">{{
                        item.qtd
                      }}</span>
                    </td>
                    <td class="text-end">
                      <button
                        @click="this.downloadArquivo(item.dirName)"
                        type="button"
                        class="btn btn-sm btn-primary"
                      >
                        <span class="svg-icon svg-icon-2">
                          <inline-svg
                            src="media/icons/duotune/files/fil021.svg"
                          />
                        </span>
                        Download
                      </button>
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr class="odd">
                  <td :colSpan="12" class="dataTables_empty">
                    <Vue3Lottie :animationData="LoadingJSON" width="40%" />
                    <div
                      class="d-flex justify-content-center align-items-center align-self-center"
                    >
                      <div class="ms-4 fs-4 text-gray-800 text-center">
                        Aguarde...
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingArquivosXMLNFe'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingModal === true"
  ></LoadingModal>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import LoadingJSON from "/public/media/animation/loading2.json";
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
export default {
  components: {
    LoadingModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async carregarArquivos() {
      try {
        this.loading = true;
        this.diretoriosDownload = [];
        var response = await this.$store.dispatch(
          "gerenciadorNFe/getXMLDownload"
        );

        if (response.Success === true) {
          this.diretoriosDownload = response.Data;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    async downloadArquivo(anomes) {
      try {
        let alert = await Swal.fire({
          title: "Deseja realizar o download o mês selecionado?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          try {
            this.loadingModal = true;
            await this.exibirModalLoading(true);

            let result = await this.$store.dispatch(
              "gerenciadorNFe/DownloadDiretorio",
              anomes
            );

            if (result.Success === true && result.Data) {
              var fileURL = [];
              let blob = this.$utils.dataToBlob(result.Data);
              fileURL = window.URL.createObjectURL(new Blob([blob]), {
                type: result.Data.ContentType,
              });

              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", result.Data.FileDownloadName);
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          } catch (error) {
            if (error.Message) {
              await this.showInvalidAlert(error.Message);
            } else {
              await this.showInvalidAlert(error);
            }
          }

          await this.exibirModalLoading(false);
          this.loadingModal = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loadingModal = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingArquivosXMLNFe");
      } else {
        await this.sleep(500);
        hideModalId("loadingArquivosXMLNFe");
        await this.sleep(100);
        this.loadingModal = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
  },
  async mounted() {
    await this.carregarArquivos();
  },
  data() {
    return {
      loading: false,
      loadingModal: false,
      errosValidacaoGeral: [],
      diretoriosDownload: [],
      LoadingJSON,
      mensagemLoading: "",
    };
  },
};
</script>

<style lang="scss" scoped></style>
